function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21 7v10c0 3-1.5 5-5 5H9c1.21-.91 2-2.37 2-4 0-2.76-2.24-5-5-5-1.13 0-2.17.37-3 1V7c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 3.75a.75.75 0 01.75.75v2c0 .686.564 1.25 1.25 1.25h2a.75.75 0 010 1.5h-2a2.756 2.756 0 01-2.75-2.75v-2a.75.75 0 01.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-.84 6.27c.25.25.25.66 0 .92-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19l-1.73-1.73a.658.658 0 010-.92l1.73-1.73c.25-.25.66-.25.92 0 .25.25.25.66 0 .92L3.89 18l1.27 1.27zm4.32-.81l-1.73 1.73c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19a.658.658 0 010-.92L8.1 18l-1.27-1.27a.658.658 0 010-.92c.25-.25.66-.25.92 0l1.73 1.73c.25.26.25.66 0 .92z"
})));